import axios from 'axios'

export default {
	props: [
		/**
		 * basket prop guaranteed to be an object due to the defaultValue in `routes.js`
		 * @type {Object}
		 */
		'basket'
	],

	data() {
		return {
			recentEntities: [],
			basketEntities: [],
		}
	},

	watch: {
		basket: {
			immediate: true,
			handler() {
				this.hydrateBasketEntitiesFromSeeds()
			}
		}
	},

	methods: {
		hydrateBasketEntitiesFromSeeds() {
			// The seeds in the `basket` prop`, passed from the router
			const seeds = this.basket.seeds || []
			// Seeds which need hydrating (i.e. not in recentEntities cache)
			const drySeeds = []

			// Avoid duplicates and stale data by fully refreshing the entities every time
			this.basketEntities = []

			seeds.forEach(seed => {
				let foundRecentEntity = this.recentEntities.find(recentEntity =>
					recentEntity.entityType === seed.entityType && recentEntity.entityId === seed.entityId
				)

				if (foundRecentEntity) {
					this.basketEntities.push(foundRecentEntity)
				} else {
					drySeeds.push(seed)
				}
			})

			if (drySeeds.length > 0) {
				this.hydrateSeeds(drySeeds).then((newEntities) => {
					this.basketEntities.push(...newEntities)
				})
			}
		},

		addEntitiesToBasket(newEntities, routeName) {
			// Ensure add is an array
			newEntities = Array.isArray(newEntities) ? newEntities : [newEntities]

			let newSeeds  = this.basket.seeds ? [...this.basket.seeds] : []

			newEntities.forEach( entity => {
				if (this.basketContainsEntity(entity) === false) {
					newSeeds.push({entityType : entity.entityType, entityId : entity.entityId})
				}
			})

			this.updateSeeds(newSeeds, routeName)
		},

		basketContainsEntity(entity) {
			return !!this.basket.seeds && !!this.basket.seeds.find(seed => seed.entityId === entity.entityId)
		},

		removeEntityFromBasket(entityToRemove, routeName) {
			let newSeeds = this.basket.seeds.filter(entity => entity.entityId !== entityToRemove.entityId)
			this.updateSeeds(newSeeds, routeName)
		},

		updateSeeds(newSeeds, routeName) {
			const basketCopy = Object.assign({}, this.$route.params.basket)
			const paramsCopy = Object.assign({}, this.$route.params)

			// If any seeds were passed, use them. Otherwise bin the seeds property
			if (Array.isArray(newSeeds) && newSeeds.length > 0) {
				basketCopy.seeds = newSeeds
			} else {
				delete basketCopy.seeds
			}

			// If any basket properties remain, use them. Otherwise bin the basket property
			if (Object.keys(basketCopy).length > 0) {
				paramsCopy.basket = JSON.stringify(basketCopy)
			} else {
				delete paramsCopy.basket
			}

			if (Object.keys(paramsCopy).length > 0) {
				this.$router.push({
					name   : routeName || this.$route.name,
					params : paramsCopy
				})
			} else {
				this.$router.push({name : routeName || this.$route.name})
			}
		},

		/**
		 * Go to a amedw route, retaining the basket param in the process
		 * @param  {String}  routeName    The name of the route to push
		 */
		goToWithBasket(routeName) {
			this.$router.push({
				name   : routeName,
				params : {basket : JSON.stringify(this.basket)}
			})
		},

		/**
		 * Go to a named route, retaining the basket seeds in the process
		 * @param  {String}  routeName    The name of the route to push
		 */
		goToWithSeeds(routeName) {
			if (!this.basket.seeds) {
				return this.$router.push(routeName)
			}

			this.$router.push({
				name   : routeName,
				params : {basket : JSON.stringify({seeds : this.basket.seeds})}
			})

		},

		goBack() {
			this.$router.go(-1)
		},

		hydrateSeeds(seeds) {
			return axios.get(this.$baseApiUrl + '/entities-from-seeds?seeds=' + JSON.stringify(seeds))
				.then(response => {
					// Cache the newly fetched entities
					this.recentEntities.push(...response.data.data)
					return response.data.data
				});
		},
	}
}
